import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=9d671b62"
import script from "./header.ts?vue&type=script&lang=js&external"
export * from "./header.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports